var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 76,
    viewBox: "0 0 93 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_188_93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_188_93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.4952 0.660156H11.9273C6.05593 0.660156 1.27917 5.43692 1.27917 11.3083V20.0921L40.3563 49.1582C42.2568 50.5717 44.4841 51.2787 46.7113 51.2787C48.9386 51.2787 51.1658 50.572 53.0663 49.1582L92.1434 20.0921V11.3083C92.1434 5.43692 87.3666 0.660156 81.4952 0.660156ZM85.0446 16.5251L48.8298 43.4622C47.5627 44.4047 45.86 44.4047 44.593 43.4622L8.37795 16.5251V11.3083C8.37795 9.35118 9.97019 7.75892 11.9273 7.75892H81.4952C83.4523 7.75892 85.0446 9.35118 85.0446 11.3083V16.5251ZM85.0446 25.3723L92.1434 20.0921V63.8391C92.1434 69.7106 87.3666 74.4873 81.4952 74.4873H11.9273C6.05593 74.4873 1.27917 69.7106 1.27917 63.8391V20.0921L8.37795 25.3723V63.8391C8.37795 65.7962 9.97019 67.3885 11.9273 67.3885H81.4952C83.4523 67.3885 85.0446 65.7962 85.0446 63.8391V25.3723Z",
    fill: "#0360D8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 74.963,
    fill: "white",
    transform: "translate(0.586304 0.438477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_188_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 74.963,
    fill: "white",
    transform: "translate(0.586304 0.438477)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_188_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 74.963,
    fill: "white",
    transform: "translate(0.586304 0.438477)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVector);
export default __webpack_public_path__ + "static/media/email_vector.b42e34c67f2d24a1768a379eb2540ca4.svg";
export { ForwardRef as ReactComponent };